// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__DTUat","calendarButtons":"ClockData_calendarButtons__1YWWt"};